import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { EMPTY_ORGANIZATIONS_EDITOR } from '../../reducers/organizationsEditor';
import { getDefaultVisitingCardEditorData } from '../../service/VisitingCardEditorHelpers/VisitingCardEditorHelpers';
import { MetroStationInfo } from '../../typings/banners';
import { ConstData, VCardConstants } from '../../typings/constants';
import { OrganizationsEditorsState, OrganizationsEditorState } from '../../typings/organizations';
import { State } from '../../typings/state';
import { VisitingCardEditorsState, VisitingCardEditorState } from '../../typings/VisitingCardEditor';

export const selectVisitingCardEditorValue = createCachedSelector(
    (state: State) => state.visitingCardEditor,
    (state: State, editorId: string) => editorId,
    (editors: VisitingCardEditorsState, editorId: string): VisitingCardEditorState => {
        return editors[editorId] || getDefaultVisitingCardEditorData();
    }
)((state: State, editorId: string) => editorId);

export const selectOrganizationsEditorValue = createCachedSelector(
    (state: State) => state.organizationsEditor,
    (state: State, editorKey: string) => editorKey,
    (editors: OrganizationsEditorsState, editorKey: string): OrganizationsEditorState => {
        return editors[editorKey] || EMPTY_ORGANIZATIONS_EDITOR;
    }
)((state: State, editorId: string) => editorId);

export const selectVisitingCardEditorMetroStations = createCachedSelector(
    selectVisitingCardEditorValue,
    (state: State) => state.commonData.metroStations,
    (
        visitingCardEditor: VisitingCardEditorState,
        metroStations?: Record<number, Array<MetroStationInfo>>
    ): Array<MetroStationInfo> | undefined => {
        const { vCardData } = visitingCardEditor;

        if (!metroStations || !vCardData) {
            return undefined;
        }

        return metroStations[vCardData.geoId];
    }
)((state: State, editorId: string) => editorId);

export const selectVCardConstants = createSelector(
    (state: State) => state.commonData.constants,
    (constants?: ConstData): VCardConstants => {
        if (!constants) {
            throw Error('constants is empty in commonData');
        } else {
            return constants.vCardConstants;
        }
    }
);
